import type { UserListPresentation } from '../../presentations';

type UserRow = React.ComponentProps<typeof UserListPresentation>['rows'][number];

type SortState = {
  key: 'no' | 'email' | 'name' | 'branchName' | 'branchCode' | 'createdAt' | null;
  direction: 'asc' | 'desc';
};

type ISortUserRows = (rows: UserRow[], sortState: SortState) => UserRow[];

/**
 * ユーザーテーブルの行をソートして返す純粋関数
 *
 * key が null のときは元の配列をそのまま返す
 */
export const sortUserRows: ISortUserRows = (rows, sortState) => {
  const { key, direction } = sortState;
  if (key === null) return rows;

  return [...rows].sort((a, b) => {
    const aVal = a[key];
    const bVal = b[key];
    const compare = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
    return direction === 'asc' ? compare : -compare;
  });
};
